import { useQuery } from '@tanstack/react-query'

import { apiGetProductPaymentProcess } from '@/payment/api'

import { PAYMENT_KEYS } from '../keys'

/**
 * `/sealed-vinyl/result?key=UUID`에서 토스/네이버 저장 데이터 조회.
 *
 * key가 falsy면 비활성화. 결과는 onceshot 데이터이므로 staleTime을 길게.
 */
export const useGetProductPaymentProcess = (key: string | null) => {
  return useQuery({
    queryKey: [PAYMENT_KEYS.PRODUCT_PAYMENT_PROCESS, key],
    queryFn: () => apiGetProductPaymentProcess(key as string),
    enabled: Boolean(key),
    staleTime: Infinity,
  })
}
